import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import DurationPicker from '../DurationPicker';
import DropDown from 'components/DropDown';
import { Mobile, Default } from 'components/Responsive';
import { H4, H5, Subtitle2, Caption, Body2 } from 'components/Typography';
import { toDaysHoursAndMinutes, toShortDateStringWithUTCOffset } from 'utilities/formatters/dateTimeFormatter';
import { withStyles } from "tss-react/mui";
import styles from './styles';
import isStringSet from 'utilities/is/isStringSet';
import m from 'messages';
import { browser } from 'components/BrowserSupport/';

class FatigueInformationPanel extends React.Component {

    fuelTypeFromWorkChanged = (e) => {
        const fuelTypeId = e.target.value;
        this.setState({ lastSwipeInFromFuelID: fuelTypeId });

        if (this.props.hasOwnProperty('fuelTypeFromWorkChanged')) {
            this.props.fuelTypeFromWorkChanged(fuelTypeId);
        }
    };

    fuelTypeToWorkChanged = (e) => {
        const fuelTypeId = e.target.value;
        this.setState({ lastSwipeInToFuelID: fuelTypeId });

        if (this.props.hasOwnProperty('fuelTypeToWorkChanged')) {
            this.props.fuelTypeToWorkChanged(fuelTypeId);
        }
    };

    travelMethodFromWorkChanged = (e) => {
        const travelMethodId = e.target.value;
        this.setState({ lastSwipeInFromTravelMethodID: travelMethodId });

        if (this.props.hasOwnProperty('travelMethodFromWorkChanged')) {
            this.props.travelMethodFromWorkChanged(travelMethodId);
        }
    };

    travelMethodToWorkChanged = (e) => {
        const travelMethodId = e.target.value;
        this.setState({ lastSwipeInToTravelMethodID: travelMethodId });

        if (this.props.hasOwnProperty('travelMethodToWorkChanged')) {
            this.props.travelMethodToWorkChanged(travelMethodId);
        }
    };

    travelDistanceFromWorkChanged = (e) => {
        const travelDistance = e.target.value;
        this.setState({ lastSwipeInFromTravelDistance: travelDistance });

        if (this.props.hasOwnProperty('travelDistanceFromWorkChanged')) {
            this.props.travelDistanceFromWorkChanged(travelDistance);
        }
    };

    travelDistanceToWorkChanged = (e) => {
        const travelDistance = e.target.value;
        this.setState({ lastSwipeInToTravelDistance: travelDistance });

        if (this.props.hasOwnProperty('travelDistanceToWorkChanged')) {
            this.props.travelDistanceToWorkChanged(travelDistance);
        }
    };

    render() {

        const { classes, editable, fatigueInformation, config } = this.props;
        const fi = fatigueInformation;

        const fuelTypesMap = {};
        config.fuelTypes.map(fuelType => fuelTypesMap[fuelType.fuelTypeID] = fuelType.fuelTypeDescription);

        const fuelTypeRenderer = (value) => {
            return isStringSet(value) ? fuelTypesMap[value] : m.general.pleaseSelect;
        };

        const travelMethodsMap = {};
        config.travelMethods.map(travelMethod => travelMethodsMap[travelMethod.travelMethodID] = travelMethod.travelMethodDescription);

        const travelMethodRenderer = (value) => {
            return isStringSet(value) ? travelMethodsMap[value] : m.general.pleaseSelect;
        };

        const travelDistancesMap = {};
        const travelDistanceValues = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

        travelDistanceValues.map(n => travelDistancesMap[n] = n + " miles");

        const travelDistanceRenderer = (value) => {
            return value == '' ? "0 miles" : travelDistancesMap[value];
        };

        const isMobile = window.innerWidth < 768;

        return (
            
            <Grid container spacing={1}>
                {isMobile ? (fi &&
                    <React.Fragment>
                        <Grid item xs={12} className={classes.wrapper}>
                            <H4>{m.cards.fatigueInformationHeader}</H4>
                            <Caption className={classes.fatigueCaption}>
                                {m.cards.fatigueInformationSubtitle}
                            </Caption>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        <Grid item md={4} sm={12} xs={12}>
                            <div className={classes.wrapper}>
                                <Subtitle2>{m.cards.timeSinceLastSwipe}</Subtitle2>
                                <Body2>
                                    {fi.swipedIn ? m.cards.stillSwipedIn : toDaysHoursAndMinutes(fi.timeSinceLastSwipeOutInMin, false)}
                                </Body2>
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <H5>
                                                    {m.cards.travelToSite}
                                                </H5>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeFrom}
                                                </Subtitle2>

                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeFromPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeFromPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeFrom}
                                                    onChange={this.props.timeFromWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.fuelTypeFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromFuelID || ''}
                                                    onChange={this.fuelTypeFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={fuelTypeRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.fuelTypes.map((fuelType, index) =>
                                                        <MenuItem key={index} value={fuelType.fuelTypeID}>
                                                            {fuelType.fuelTypeDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelMethodFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromTravelMethodID || ''}
                                                    onChange={this.travelMethodFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelMethodRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.travelMethods.map((travelMethod, index) =>
                                                        <MenuItem key={index} value={travelMethod.travelMethodID}>
                                                            {travelMethod.travelMethodDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelDistanceFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromTravelDistance || ''}
                                                    onChange={this.travelDistanceFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelDistanceRenderer}>
                                                    {travelDistanceValues.map((n, index) =>
                                                        <MenuItem key={index} value={n}>
                                                            {n + " miles"}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <H5>
                                                    {m.cards.travelFromSite}
                                                </H5>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeTo}
                                                </Subtitle2>
                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeToPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeToPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeTo}
                                                    onChange={this.props.timeToWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.fuelTypeTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToFuelID || ''}
                                                    onChange={this.fuelTypeToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={fuelTypeRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.fuelTypes.map((fuelType, index) =>
                                                        <MenuItem key={index} value={fuelType.fuelTypeID}>
                                                            {fuelType.fuelTypeDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelMethodTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToTravelMethodID || ''}
                                                    onChange={this.travelMethodToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelMethodRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.travelMethods.map((travelMethod, index) =>
                                                        <MenuItem key={index} value={travelMethod.travelMethodID}>
                                                            {travelMethod.travelMethodDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelDistanceTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToTravelDistance || ''}
                                                    onChange={this.travelDistanceToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelDistanceRenderer}>
                                                    {travelDistanceValues.map((n, index) =>
                                                        <MenuItem key={index} value={n}>
                                                            {n + " miles"}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        {fi.previousLocations && fi.previousLocations.length > 0 &&
                            <Grid item xs={12}>
                                <H5 paragraph>{m.cards.previousLocations}</H5>

                                <Default>
                                    <Grid container>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.site}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.timeIn}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.timeOut}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.lastShiftDuration}
                                            </Subtitle2>
                                        </Grid>
                                    </Grid>
                                </Default>
                            </Grid>
                        }

                        {fi.previousLocations && fi.previousLocations.map((pl, index) =>
                            <Grid key={index} item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.previousSite}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {pl.lastKnownSiteName}
                                            {isStringSet(pl.externalCardScheme) &&
                                                <p>
                                                    {m.cards.linkedSchemeLabel}: {pl.externalCardScheme}
                                                </p>
                                            }
                                        </Body2>
                                        
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedIn}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeInTimeLocal, pl.lastKnownSwipeInTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedOut}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeOutTimeLocal, pl.lastKnownSwipeOutTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.lastShiftDuration}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toDaysHoursAndMinutes(pl.lastKnownShiftDurationInMin, false)}
                                        </Body2>
                                    </Grid>                                                                      
                                </Grid>
                                <Divider className={classes.divider} />
                            </Grid>
                        )}
                    </React.Fragment>
                ) : (fi &&
                    <React.Fragment>
                        <Grid item xs={12} className={classes.wrapper}>
                            <H4>{m.cards.fatigueInformationHeader}</H4>
                            <Caption className={classes.fatigueCaption}>
                                {m.cards.fatigueInformationSubtitle}
                            </Caption>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        <Grid item md={4} sm={12} xs={12}>
                            <div className={classes.wrapper}>
                                <Subtitle2>{m.cards.timeSinceLastSwipe}</Subtitle2>
                                <Body2>
                                    {fi.swipedIn ? m.cards.stillSwipedIn : toDaysHoursAndMinutes(fi.timeSinceLastSwipeOutInMin, false)}
                                </Body2>
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <H5>
                                                    {m.cards.travelToSite}
                                                </H5>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <H5>
                                                    {m.cards.travelFromSite}
                                                </H5>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeFrom}
                                                </Subtitle2>

                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeFromPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeFromPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeFrom}
                                                    onChange={this.props.timeFromWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeTo}
                                                </Subtitle2>
                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeToPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeToPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeTo}
                                                    onChange={this.props.timeToWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.fuelTypeFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromFuelID || ''}
                                                    onChange={this.fuelTypeFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={fuelTypeRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.fuelTypes.map((fuelType, index) =>
                                                        <MenuItem key={index} value={fuelType.fuelTypeID}>
                                                            {fuelType.fuelTypeDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.fuelTypeTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToFuelID || ''}
                                                    onChange={this.fuelTypeToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={fuelTypeRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.fuelTypes.map((fuelType, index) =>
                                                        <MenuItem key={index} value={fuelType.fuelTypeID}>
                                                            {fuelType.fuelTypeDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelMethodFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromTravelMethodID || ''}
                                                    onChange={this.travelMethodFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelMethodRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.travelMethods.map((travelMethod, index) =>
                                                        <MenuItem key={index} value={travelMethod.travelMethodID}>
                                                            {travelMethod.travelMethodDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelMethodTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToTravelMethodID || ''}
                                                    onChange={this.travelMethodToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelMethodRenderer}>
                                                    <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                                                    {config.travelMethods.map((travelMethod, index) =>
                                                        <MenuItem key={index} value={travelMethod.travelMethodID}>
                                                            {travelMethod.travelMethodDescription}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelDistanceFrom}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInFromTravelDistance || ''}
                                                    onChange={this.travelDistanceFromWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelDistanceRenderer}>
                                                    {travelDistanceValues.map((n, index) =>
                                                        <MenuItem key={index} value={n}>
                                                            {n + " miles"}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelDistanceTo}
                                                </Subtitle2>

                                                <DropDown
                                                    className={classes.dropdown}
                                                    value={fi.lastSwipeInToTravelDistance || ''}
                                                    onChange={this.travelDistanceToWorkChanged}
                                                    displayEmpty={true}
                                                    renderValue={travelDistanceRenderer}>
                                                    {travelDistanceValues.map((n, index) =>
                                                        <MenuItem key={index} value={n}>
                                                            {n + " miles"}
                                                        </MenuItem>
                                                    )}
                                                </DropDown>
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        {fi.previousLocations && fi.previousLocations.length > 0 &&
                            <Grid item xs={12}>
                                <H5 paragraph>{m.cards.previousLocations}</H5>

                                <Default>
                                    <Grid container>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.site}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.timeIn}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.timeOut}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Subtitle2>
                                                {m.cards.lastShiftDuration}
                                            </Subtitle2>
                                        </Grid>
                                    </Grid>
                                </Default>
                            </Grid>
                        }

                        {fi.previousLocations && fi.previousLocations.map((pl, index) =>
                            <Grid key={index} item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.previousSite}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {pl.lastKnownSiteName}
                                            {isStringSet(pl.externalCardScheme) &&
                                                <p>
                                                    {m.cards.linkedSchemeLabel}: {pl.externalCardScheme}
                                                </p>
                                            }
                                        </Body2>

                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedIn}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeInTimeLocal, pl.lastKnownSwipeInTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedOut}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeOutTimeLocal, pl.lastKnownSwipeOutTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.lastShiftDuration}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toDaysHoursAndMinutes(pl.lastKnownShiftDurationInMin, false)}
                                        </Body2>
                                    </Grid>
                                </Grid>
                                <Divider className={classes.divider} />
                            </Grid>
                        )}
                    </React.Fragment>
                )
                }
            </Grid>
        );
    }
}

FatigueInformationPanel.propTypes = {
    editable: PropTypes.bool,
    fatigueInformation: PropTypes.object,
    config: PropTypes.object.isRequired
};

export default withStyles(FatigueInformationPanel,styles);
